import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapper from "../../components/PageWrapper";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import {
  LoadWalletManagement,
  SchemeManagement,
} from "../../config/tableConfigs";
import PageWrapperForm from "../../components/PageWrapperForm";
import SchemeFormModal from "./components/schemeFormModal"; // ✅ fixed
import DeleteModal from "../../components/DeleteModal";
import LoadWalletAddNewRequest from "./components/LoadWalletAddNewRequest";
import LoadWalletPayThroughUpi from "./components/LoadWalletPayThroughUpi";
import { useSession } from "hooks/useSession";

const LoadWalletAmount = () => {
  const [addNewRequest, setAddNewRequest] = useState(false);
  const [payThroughUpi, setPayThroughUpi] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0); 
  const {userid}= useSession();

  function handleUpiClick() {
    setPayThroughUpi(true);
  }

  function handleSecondaryBtnClick() {
    setAddNewRequest(true);
  }

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://api.mokshiq.in/scheme_manager_action",
    SchemeManagement,
    formdata, 
    refresh
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setAddNewRequest(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deletescheme1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(
        `Are you sure you want to delete ${selectedIds.length} records?`
      )
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    // setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={LoadWalletManagement}
        handleOnclick={handleUpiClick}
        buttonTitle={"Pay Through UPI"}
        handleSecondaryOnclick={handleSecondaryBtnClick}
        secondaryButtonTitle={"+ New Request"}
      >
        <DataTable
          config={SchemeManagement}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <LoadWalletPayThroughUpi
        show={payThroughUpi}
        onClose={() => setPayThroughUpi(false)}
        title={"Add Request"}
      />
      <LoadWalletAddNewRequest
        show={addNewRequest}
        onClose={() => setAddNewRequest(false)}
        title={"Add Load Wallet"}
      />

      <DeleteModal
      deleteid={selectedUser}

        id="deletescheme1"
        title="Delete Scheme"
        message="Are you sure you want to delete this scheme?"
        apiUrl="https://api.mokshiq.in/scheme_manager_action"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default LoadWalletAmount;
